import React from 'react';

import { trans } from '../../../localization';

import NowMerchantLogo from '../../../assets/common/static/img/favicon.png';
import './AppMobile.scss';

class AppMobile extends React.Component {
  render() {
    return (
      <div className="m-show">
        <div className="content">
          <div className="logo">
            <img src={NowMerchantLogo} alt="logo" />
          </div>
          {trans('rebranding.common_please_use_app')}
          <div className="down-app">
            <a href="https://apps.apple.com/vn/app/shopee-partner/id1615746024?l=vi">
              <span className="icon icon-app-store" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.shopeepay.merchant.vn&hl=vi&gl=VN">
              <span className="icon icon-gg-play" />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default AppMobile;



// WEBPACK FOOTER //
// ./foody/src/layout/components/AppMobile/AppMobile.jsx